module.exports = __webpack_public_path__ + "media/images/pic/sample1-44696c76d9a7cc93cbd765f5528a63a8.jpg";